
import { BaseTLTableComponent, AxiosResponse, VpnReservedService, VpnReservedFilter,  Vue, BaseTLTableBase } from "../../../Infrastructure/CorBase/CoreBase";

	export default abstract class VpnReservedListBase extends BaseTLTableComponent {
		vpnReservedService: VpnReservedService = new VpnReservedService();

		isBusy = false;

		loadBaseVpnAndFilters() {
			let filter: VpnReservedFilter = new VpnReservedFilter();
			this.vpnReservedService.getAllBaseVpn(filter).then(res => {
				this.itemsAnswer = [];
                for (var i = 0; i < res.data.length; i++) {
					this.itemsAnswer.push({ value: res.data[i].addressText, text: res.data[i].addressText });
				}	
				this.filters = [
					{ key: 'idVpnBaseIpRangeText', label: this.$t('vpnReserved.fieldVpnBaseIpRange'), selected: false, value: null, type: 'text', useOwnEnumsSend: true, useOwnEnumsSendArray: this.itemsAnswer, lang: this.$store.state.currentLanguage },
					{ key: 'name', label: this.$t('vpnReserved.fieldName'), trans: 'vpnReserved.fieldName', selected: false, value: null, type: 'text' },
					{ key: 'addressText', label: this.$t('vpnReserved.fieldAddress'), trans: 'vpnReserved.fieldAddress', selected: false, value: null, type: 'text' },
					{ key: 'cidr', label: this.$t('vpnReserved.fieldCidr'), trans: 'vpnReserved.fieldCidr', selected: false, value: null, type: 'text' }
				]
			});
		}

		fetchDataFromServer(): Promise<AxiosResponse<any>> {
			let filter: VpnReservedFilter = new VpnReservedFilter();
			return this.vpnReservedService.getAllByFilter(filter)
		}

		prepareItems(items: any[]) {

		}

		//zatím nepotrebujeme
		fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
			return this.fetchDataFromServer();
		}

		refreshItems(items: any[], refreshData: any[]) {
			return items;
		}

		itemsAnswer = [
			{ value: this.$t('global.answerYes').toString(), text: this.$t('global.answerYes').toString() },
			{ value: this.$t('global.answerNo').toString(), text: this.$t('global.answerNo').toString() }];

		//nastavení sloupcu tabulky
		setFields() {
			this.fields = [
				{ key: 'idVpnBaseIpRangeText', label: this.$t('vpnReserved.fieldVpnBaseIpRange'), trans: 'vpnReserved.fieldVpnBaseIpRange', sortable: true, class: 'text-center' },
				{ key: 'name', label: this.$t('vpnReserved.fieldName'), trans: 'vpnReserved.fieldName', sortable: true, class: 'text-center', design: 'detail' },
				{ key: 'addressText', label: this.$t('vpnReserved.fieldAddress'), trans: 'vpnReserved.fieldAddress', sortable: true, class: 'text-center' },
				{ key: 'cidr', label: this.$t('vpnReserved.fieldCidr'), trans: 'vpnReserved.fieldCidr', sortable: true, class: 'text-center' },			
				{ key: 'actions', label: this.$t('vpnReserved.fieldActions'), trans: 'vpnReserved.fieldActions', class: 'text-right' }
			]
		};


		//filtry
		 setfilters(value: any) {
			 if (value != null && value[0].lang == this.filters[0].lang) {
				this.filters = value;
			}
			else {
				 this.loadBaseVpnAndFilters();
			}
		}

		callActionClick() {			
			this.isBusy = true;
			if (this.itemsSelected) {
				// bud mame pole cisel - kliklo se na tlacitko smazat pod tabulkou
				let idList: number[] = this.itemsSelected as number[];
				// nebo mame pouze jedno cislo - kliklo se na ikonu kose na radku
				if (idList.length == undefined || idList.length <= 0) {
					let id: number = this.itemsSelected as number;
					if (id) {
						idList = [id];
					}
				}
				if (idList.length > 0) {
					this.isBusy = true;
					this.deleteItemsList = idList;
					super.deleteList();
				}
			}
			this.itemsSelected = null;
			(this.$refs.vpnReservedTable as BaseTLTableBase).clearSelected();
		}


		protected deleteListServer(): Promise<AxiosResponse<any>> {
			return this.vpnReservedService.deleteList(this.deleteItemsList);
		}

		// VaP - toto zde musi byt, jinak nefunguje napojeni na tabulku
		loadFilters(value: any) { super.loadFilters(value); };
		createNewClick(elementId: any) { super.createNewClick(elementId); }
		detailClick(elementId: any) { super.detailClick(elementId); };
		deleteClick(elementId: any) { super.deleteClick(elementId); };
	}

